import { collection, doc, setDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const notesService = {
  addNote: async (userId, noteId, noteText, llmOutput, title) => {
    const noteRef = doc(db, "users", userId, "notes", noteId);
    const time = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    try {
      await setDoc(noteRef, {
        text: noteText,
        llmOutput: llmOutput,
        title: title || "New Note",
        time: time,
        date_generated: serverTimestamp(),
      });
      console.log("✅ Note saved to Firestore");
    } catch (err) {
      console.error("❌ Error writing note:", err);
      throw err;
    }
  },

  fetchNotes: async (userId) => {
    try {
      const notesRef = collection(db, "users", userId, "notes");
      const snapshot = await getDocs(notesRef);
      return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (err) {
      console.error("❌ Error fetching notes:", err);
      return [];
    }
  },
};

export default notesService;
